import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Chip,
  Avatar,
  Stack,
  alpha,
  Card,
  CardContent,
} from "@mui/material";
import {
  Assignment,
  CalendarToday,
  LocationOn,
  Person,
  Description,
  Business,
  Numbers,
  FormatListBulleted,
} from "@mui/icons-material";

const DetalleReclamo = ({ row, getEstadoViajeColor, formatFecha }) => {
  const reclamo = row.original;
  const estadoColors = getEstadoViajeColor(reclamo.estado_viaje);

  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        backgroundColor: "white",
        borderLeft: `4px solid ${estadoColors.bg}`,
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: 1,
          backgroundColor: "white",
        },
      }}
    >
      <CardContent sx={{ p: 2 }}>
        {/* Cabecera con ID y Estado */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar
              sx={{
                bgcolor: alpha(estadoColors.bg, 0.15),
                width: 32,
                height: 32,
                border: `2px solid ${estadoColors.bg}`,
              }}
            >
              <Numbers sx={{ fontSize: 16, color: estadoColors.bg }} />
            </Avatar>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                Reclamo #{reclamo.id_reclamo}
              </Typography>
              <Chip
                label={reclamo.estado_viaje || "Desconocido"}
                size="small"
                sx={{
                  backgroundColor: estadoColors.bg,
                  color: estadoColors.color,
                  fontSize: "0.7rem",
                  height: 22,
                  fontWeight: 600,
                }}
              />
            </Box>
          </Stack>

          <Box display="flex" gap={0.5}>
            <Chip
              icon={<CalendarToday sx={{ fontSize: 12 }} />}
              label={`Apertura: ${formatFecha(reclamo.fecha_abierto)}`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ fontSize: "0.75rem" }}
            />
            {reclamo.fecha_finalizacion_viaje && (
              <Chip
                icon={<CalendarToday sx={{ fontSize: 12 }} />}
                label={`Fin: ${formatFecha(reclamo.fecha_finalizacion_viaje)}`}
                size="small"
                color="success"
                variant="outlined"
                sx={{ fontSize: "0.75rem" }}
              />
            )}
          </Box>
        </Box>

        <Grid container spacing={1.5}>
          {/* Primera fila: Cliente y Proveedor */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Cliente"
              value={reclamo.cliente_razon_social || "-"}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <Person fontSize="small" sx={{ color: "#1976d2", mr: 1 }} />
                ),
                sx: { fontSize: "0.875rem" },
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Proveedor"
              value={reclamo.proveedor_razon_social || "-"}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <Business fontSize="small" sx={{ color: "#2e7d32", mr: 1 }} />
                ),
                sx: { fontSize: "0.875rem" },
              }}
              variant="outlined"
            />
          </Grid>

          {/* Segunda fila: Motivo y Remito */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Motivo"
              value={reclamo.descripcion_motivo || "-"}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <Assignment
                    fontSize="small"
                    sx={{ color: "#ed6c02", mr: 1 }}
                  />
                ),
                sx: { fontSize: "0.875rem" },
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Remito"
              value={reclamo.nro_remito || "-"}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <Description
                    fontSize="small"
                    sx={{ color: "#9c27b0", mr: 1 }}
                  />
                ),
                sx: { fontSize: "0.875rem" },
              }}
              variant="outlined"
            />
          </Grid>

          {/* Tercera fila: Dirección y Localidad */}
          <Grid item xs={12} sm={8}>
            <TextField
              fullWidth
              size="small"
              label="Dirección"
              value={reclamo.direccion_entrega || "-"}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <LocationOn
                    fontSize="small"
                    sx={{ color: "#1976d2", mr: 1 }}
                  />
                ),
                sx: { fontSize: "0.875rem" },
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              size="small"
              label="Localidad"
              value={reclamo.localidad || ""}
              InputProps={{
                readOnly: true,
                sx: { fontSize: "0.875rem" },
              }}
              variant="outlined"
            />
          </Grid>

          {/* Cuarta fila: Detalles */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              label="Detalles"
              multiline
              rows={2}
              value={reclamo.detalle || "-"}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <FormatListBulleted
                    fontSize="small"
                    sx={{ color: "#757575", mr: 1, mt: 0.5 }}
                  />
                ),
                sx: { fontSize: "0.875rem", alignItems: "flex-start" },
              }}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DetalleReclamo;
